<template>
  <div>
    <hit_login>

      <hit_dashboard>

        <div class="hit-row">
        <div class="hit-col-md-2 hit-text-center hit-text-info">
          <div class="hit-form-group">
            <i class="hit-glyphicon hit-glyphicon-user" style="font-size: 5em;"></i>
            <div style="font-size: 3em; line-height: 1em;">{{ $store.getters.user.ID }}</div>
            <div style="">User-ID</div>
          </div>
        </div>

        <div class="hit-col-md-10">
          <div class="hit-panel hit-panel-info">
            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-user"></i> {{ $store.getters.user.username }}
            </div>

            <div class="hit-panel-body">

              <div class="hit-row">
              <div v-for="(element, index) in form" v-bind:class="get_class(element[0])">
                <div class="hit-form-group">
                  <label class="hit-html-label" v-bind:for="'form_'+index">{{ $tc("message."+[element[1]], 1) }}</label>
                  <input v-on:change="function(col){ set_user(col.target.value, element); }" spellcheck="false" v-bind:id="'form_'+index" type="text" v-model="$store.getters.user[element[1]]" class="hit-form-control">
                </div>
              </div>

            </div>

            </div>

            <div class="hit-panel-heading">
              <hit_icon :id='"cogwheel"' /> {{ $tc("message.settings", 2) }}
            </div>

            <div class="hit-panel-body">
              <settings />
            </div>

            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-brush"></i> {{ $t("message.default", {name: $tc("message.color", 2)}) }}
            </div>

            <div class="hit-panel-body">

              <div class="hit-row">
                <div class="hit-col-md-4">
                  <div class="hit-form-group">
                  <h5 class="hit-html-h5">{{ $t("message.preview") }}</h5>
                    <hit_badge class="hit-html-html hit_badge_container" :design="'Maria'" :survey='{ name: "Demo", votes: {1:0, 2:0,3:0,4:10,5:100}, badge: {bg: $store.getters.user.background_color, accent: $store.getters.user.accent_color, text: $store.getters.user.text_color, pluscolor: $store.getters.user.accent_color2}, all: 9875, all_percent: 4.87 }'/>
                  </div>
                </div>

                <div class="hit-col-md-8">

                  <div class="hit-form-group">

                  <div v-for="(element, index) in form2" v-bind:class="get_class(element[0])">
                    <div class="hit-form-group">
                      <label class="hit-html-label" v-bind:for="'form2_'+index" v-html="get_label(element)"></label>
                      <hit_color :id="'form2_'+index" :color="$store.getters.user[element[1]]" :callback="function(col){ set_user(col, element); }"/>
                    </div>
                  </div>

                </div>

              </div>

            </div>

            </div>

            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-briefcase"></i> {{ $t("message.default", {name: $t("message.imprint")}) }}
            </div>

            <div class="hit-panel-body">

              <div class="hit-row">
              <div class="hit-col-md-12">
                <div class="hit-form-group">

                  <ckeditor id="imprint" :editor="editor" v-model="imprint" :config="editorConfig"></ckeditor>

                </div>

              </div>

            </div>

            </div>

            <div class="hit-panel-heading">
              <i class="hit-glyphicon hit-glyphicon-briefcase"></i> {{ $t("message.default", {name: $t("message.privacy")}) }}
            </div>

            <div class="hit-panel-body">

              <div class="hit-row">
              <div class="hit-col-md-12">

                <div class="hit-form-group">

                  <ckeditor id="privacy" :editor="editor" v-model="privacy" :config="editorConfig"></ckeditor>

                </div>
              </div>

            </div>

            </div>

          </div>
        </div>
        </div>

      </hit_dashboard>

    </hit_login>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'
import settings from '@core/components/content/app/profile/settings'

export default {

  components: {settings},

  data: function () {
    return {

      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList' ],
        language: 'de'
      },

      form: [
        [12, 'company'],
        [6, 'first_name'],
        [6, 'last_name'],
        [5, 'adress'],
        [3, 'zip'],
        [4, 'city']
      ],
      form2: [
        [12, 'background_color'],
        [12, 'text_color'],
        [12, 'accent_color'],
        [12, 'accent_color2', this.$tc('message.accent_color', 1) + ' 2']
      ],
      privacy: this.$store.getters.user.privacy,
      imprint: this.$store.getters.user.imprint

    }
  },

  watch: {

    imprint: function (val) { this.$store.commit('set_change_user', {imprint: val}) },
    privacy: function (val) { this.$store.commit('set_change_user', {privacy: val}) }

  },
  methods: {

    set_user: function (col, element) {
      var post = {}
      post[element[1]] = col

      this.$store.commit('set_change_user', post)
    },
    get_label: function (element) {
      if (typeof element[2] !== 'undefined') { return element[2] }

      return this.$tc('message.' + [element[1]], 1)
    },
    get_class: function (col) {
      var obj = {}; obj['hit-col-md-' + col ] = true; return obj
    }
  },

  metaInfo: function () {
    return {
      title: this.$t('message.edit', {name: this.$tc('message.profile', 1) })
    }
  }
}

</script>

<style scoped>

@media(max-width: 768px){

  .hit_badge_container{
    text-align: center;
    display: block;
    margin: 0 auto;

  }

}

</style>
